import type { GButtonProps } from '../inputs/GButton/GButton.props.ts';

export const defaultHeaderActionProps: Partial<GButtonProps> = {
  variant: 'plain',
  color: 'primary',
};
